import { Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { RawTrendData, Trend } from '../models/trend';

import { PortService } from './port.service';
import { Port } from '../models/port';
import { TrendMassagePipe } from '../pipes/trend-massage.pipe';

@Injectable({
  providedIn: 'root'
})
export class TrendService {

  trendDataSubject: Subject<any>;
  trendData:Trend[] = [];


  constructor(private http: HttpClient,
              private portService:PortService, private trendMassagePipe:TrendMassagePipe) { 

    this.trendDataSubject = new Subject<any>();
    this.trendDataSubject.subscribe(next => {
      this.trendData = [...this.trendData]; /* only way to get ngx charts to refresh data is refresh array */
      this.trendData.push(trendMassagePipe.transform(next.sss.a, next.sss.b, 2))
      console.log('one: got raw trend data', next)
    });

    

  }


  initTrendData(){
    this.trendData = []
  }

     /* you can decide which "set" to push to... pass a flag that says keep 
     other... keep use chronological*/
  getTrend(port: Port, start_date: number, end_date: number){
 
    this.trendData = []; //this could be better
     this.http.get<RawTrendData[]>('core-service/api/trend?trend_port_id=' + port.port_nid + '&start_date=' + new Date(start_date).toISOString() + '&end_date=' + new Date(end_date).toISOString()).pipe(
      tap((some: any) => console.log('TREND')),
      catchError(this.handleError<any>('TREND'))
    ).subscribe( res => {


        this.trendDataSubject.next({sss:{a:res, b:port}})
     
    
    })

  }

  xGetTrend( portId: number, start_date: number, end_date: number ) : Observable<[RawTrendData]> {
    return this.http.get<RawTrendData[]>('core-service/api/trend?trend_port_id=' + portId+ '&start_date=' + new Date(start_date).toISOString() + '&end_date=' + new Date(end_date).toISOString()).pipe(
     tap((some: any) => console.log('TREND')),
     catchError(this.handleError<any>('TREND'))
   )

  }


  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
   
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
   
      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);
   
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
